import { Route } from '@angular/router'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type NewsletterRoutes = {
    unsubscribe: Route
}

export const newsletterRoutes: NewsletterRoutes = {
    unsubscribe: {
        path: 'newsletter/unsubscribe',
        loadComponent: () =>
            import('./page-unsubscribe-newsletter/page-unsubscribe-newsletter.component').then(
                (m) => m.PageUnsubscribeNewsletterComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
}
